<template>
<div class="container-fluid" style="height: 100vh">
  <div class="row align-items-center" style="height: 100%;">
    <div class="col-md-5" style="height: 97%;">
      <search v-on:tablet-selected="onTabletSelected"></search>
    </div>
    <div class="col-md-7" style="height: 97%">
      <text-view v-bind:tablet_id="tablet_id"></text-view>
    </div>
  </div>
</div>
</template>

<script>
import Search from '@/components/Search'
import TextView from '@/components/TextView'

export default {
  name: 'Explorer',

  components: {
    Search,
    TextView
  },

  data () {
    return {
      tablet_id: ''
    }
  },

  methods: {
    onTabletSelected: function (id) {
      this.tablet_id = id
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Explorer.vue